var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 6.66667C3.79357 6.66667 4.16667 6.29357 4.16667 5.83333C4.16667 5.3731 3.79357 5 3.33333 5C2.8731 5 2.5 5.3731 2.5 5.83333C2.5 6.29357 2.8731 6.66667 3.33333 6.66667Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04167 5.83333C6.04167 5.48816 6.32149 5.20833 6.66667 5.20833H16.6667C17.0118 5.20833 17.2917 5.48816 17.2917 5.83333C17.2917 6.17851 17.0118 6.45833 16.6667 6.45833H6.66667C6.32149 6.45833 6.04167 6.17851 6.04167 5.83333Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 9.375C6.32149 9.375 6.04167 9.65482 6.04167 10C6.04167 10.3452 6.32149 10.625 6.66667 10.625H16.6667C17.0118 10.625 17.2917 10.3452 17.2917 10C17.2917 9.65482 17.0118 9.375 16.6667 9.375H6.66667Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 13.5417C6.32149 13.5417 6.04167 13.8215 6.04167 14.1667C6.04167 14.5118 6.32149 14.7917 6.66667 14.7917H16.6667C17.0118 14.7917 17.2917 14.5118 17.2917 14.1667C17.2917 13.8215 17.0118 13.5417 16.6667 13.5417H6.66667Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 15C3.79357 15 4.16667 14.6269 4.16667 14.1667C4.16667 13.7064 3.79357 13.3333 3.33333 13.3333C2.8731 13.3333 2.5 13.7064 2.5 14.1667C2.5 14.6269 2.8731 15 3.33333 15Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 10C4.16667 10.4602 3.79357 10.8333 3.33333 10.8333C2.8731 10.8333 2.5 10.4602 2.5 10C2.5 9.53976 2.8731 9.16667 3.33333 9.16667C3.79357 9.16667 4.16667 9.53976 4.16667 10Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuList);
export default __webpack_public_path__ + "static/media/menu-list.08072246d876312ae0fce656918ee5d4.svg";
export { ForwardRef as ReactComponent };